module.exports = __webpack_public_path__ + "static/media/feat-bite-img2.e568fe76.jpg";